import { jsx } from 'react/jsx-runtime';
import * as React from 'react';
import { forwardRef } from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function SvgCopyLink(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9 3h10a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-1V7a2 2 0 0 0-2-2H8V4a1 1 0 0 1 1-1Zm9 16v-1h1a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2v1H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2ZM16 6H6a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1Zm-8.005 8.591.707-.707a1 1 0 0 1 .966-.259l-.259.26a.5.5 0 1 0 .707.706l.26-.259a1 1 0 0 1-.26.966l-.707.707a1 1 0 1 1-1.414-1.414Zm0-1.414a2.001 2.001 0 0 1 2.43-.309l.443-.443a2.001 2.001 0 0 1 .309-2.43l.707-.707a2 2 0 0 1 2.828 2.828l-.707.707a2.001 2.001 0 0 1-2.43.31l-.443.442c.453.767.35 1.772-.309 2.43l-.707.708a2 2 0 0 1-2.828-2.829l.707-.707Zm4.596-1.06-.259.258a1 1 0 0 0 .966-.259l.707-.707a1 1 0 0 0-1.414-1.414l-.707.707a1 1 0 0 0-.259.966l.259-.259a.5.5 0 1 1 .707.707Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyLink);

var CopyLinkOutline = forwardRef((props, ref) => jsx(ForwardRef, Object.assign({
  ref: ref
}, props)));

export { CopyLinkOutline as default };
